import React from "react";
import PropTypes from "prop-types";

export default class Button extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    style: PropTypes.object,
    onClick: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.string,
    disabled: PropTypes.bool,
  };

  render() {
    let { label, style, type, children, className, disabled, ...rest } =
      this.props;

    return (
      <button
        type={type}
        className={"button-transparent " + (className || "")}
        onClick={this.props.onClick}
        title={label}
        style={style}
        disabled={disabled}
        {...rest}
      >
        {children}
      </button>
    );
  }
}

Button.defaultProps = {
  label: "",
  type: "button",
  style: {},
  onClick: () => {},
};
